export default __webpack_public_path__ + "e17d1fa18db1b6ccef7cbb811ce9ae70.png";